export default "__VITE_ASSET__f5b0ec23__"